import {
  LuArrowRight,
  LuCalendarPlus,
  LuDollarSign,
  LuHand,
  LuMail,
  LuX,
  LuZap,
} from "react-icons/lu";
import { useCallback, useEffect, useMemo, useState } from "react";

import { Modal } from "@iq/models";
import "./Modal.css";

import CreateDeal from "./CreateDeal";
import CreateFollowUpModal from "./CreateFollowUpModal";
import CreateMeetingModal from "./CreateMeetingModal";

function CompleteLogModal({
  isOpen,
  onClose,
  onProceed,
  onComposeEmail,
}) {
  const [selectedAction, setSelectedAction] = useState(null);
  const [activeModal, setActiveModal] = useState(null);


  //Closing page and extra modal logic 
  const closeCompleteLog = useCallback(() => {
    setSelectedAction(null);
    setActiveModal(null);
    onClose?.();
  }, [onClose]);

  const closeChildModal = () => {
    setSelectedAction(null);
    setActiveModal(null);
  };

  useEffect(() => {
    if(isOpen) {
      setSelectedAction(null);
      setActiveModal(null);
    }
  }, [isOpen]);


  const handleActionSelect = useCallback(() => {
    if (!selectedAction) return;

    switch (selectedAction) {
      case "create-deal":
        setActiveModal("deal");
        break;

      case "schedule-meeting":
        setActiveModal("meeting");
        break;

      case "create-follow-up":
        setActiveModal("follow-up");
        break;

      case "compose-email":
        onComposeEmail?.();
        closeCompleteLog();
        break;

      case "no-action":
        onProceed?.();
        closeCompleteLog();
        break;

      default:
        break;
    }
  }, [selectedAction, onProceed, onComposeEmail, closeCompleteLog]);

  const actionButtons = useMemo(
    () => [
      {
        key: "proceed",
        text: "Proceed",
        icon: <LuArrowRight />,
        type: "button",
        color: "secondary",
        onClick: handleActionSelect,
      },
    ],
    [handleActionSelect]
  );

  return (
    <>
      <Modal
        isOpen={isOpen && activeModal === null}
        onClose={closeCompleteLog}
        icon={<LuZap />}
        title="Complete Log"
        actionButtons={actionButtons}
      >
        <div className="modal-form-field">
          <label>Select Next Action</label>

          <div className="modal-form-options-3">
            <div
              className={`modal-form-option-button ${
                selectedAction === "create-deal"
                  ? "modal-form-option-field-active"
                  : ""
              }`}
              onClick={() => setSelectedAction("create-deal")}
            >
              <LuDollarSign />
              <span>Create Deal</span>
            </div>

            <div
              className={`modal-form-option-button ${
                selectedAction === "schedule-meeting"
                  ? "modal-form-option-field-active"
                  : ""
              }`}
              onClick={() => setSelectedAction("schedule-meeting")}
            >
              <LuCalendarPlus />
              <span>Schedule Meeting</span>
            </div>

            <div
              className={`modal-form-option-button ${
                selectedAction === "create-follow-up"
                  ? "modal-form-option-field-active"
                  : ""
              }`}
              onClick={() => setSelectedAction("create-follow-up")}
            >
              <LuHand />
              <span>Create Follow-Up</span>
            </div>

            <div
              className={`modal-form-option-button ${
                selectedAction === "compose-email"
                  ? "modal-form-option-field-active"
                  : ""
              }`}
              onClick={() => setSelectedAction("compose-email")}
            >
              <LuMail />
              <span>Compose Email</span>
            </div>

            <div
              className={`modal-form-option-button ${
                selectedAction === "no-action"
                  ? "modal-form-option-field-active"
                  : ""
              }`}
              onClick={() => setSelectedAction("no-action")}
            >
              <LuX />
              <span>No Further Action</span>
            </div>
          </div>
        </div>
      </Modal>

      <CreateDeal
        isOpen={isOpen && activeModal === "deal"}
        onClose={closeChildModal}
      />

      <CreateMeetingModal
        isOpen={isOpen && activeModal === "meeting"}
        onClose={closeChildModal}
      />

      <CreateFollowUpModal
        isOpen={isOpen && activeModal === "follow-up"}
        onClose={closeChildModal}
      />


      
    </>
  );
}

export default CompleteLogModal;